import { API } from "../api";

export const memberSavingsWithdrawalApi = API.injectEndpoints({
  endpoints: (builder) => ({
    // Create withdrawal request
    createWithdrawalRequest: builder.mutation({
      query: (body) => ({
        url: "/members/savings/withdraw-request?guard=member",
        method: "POST",
        body: body,
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "MemberWithdrawalRequests", id: "LIST" },
        { type: "MemberContribution", id: "SUMMARY" },
      ],
    }),

    // Get my withdrawal requests with pagination
    getMyWithdrawalRequests: builder.query({
      query: ({ page = 1, limit = 20, status = "all" }) => {
        const params = new URLSearchParams({
          guard: "member",
          page: page.toString(),
          limit: limit.toString(),
        });
        if (status && status !== "all") {
          params.append("status", status);
        }
        return {
          url: `/members/savings/withdrawal-requests?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => {
        const { withdrawal_requests = [], pagination = {} } =
          responseData?.data || {};
        return {
          withdrawalRequests: withdrawal_requests,
          pagination,
        };
      },
      providesTags: (result, error, arg) => [
        { type: "MemberWithdrawalRequests", id: "LIST" },
      ],
    }),

    // Cancel withdrawal request (only if status is PENDING)
    cancelWithdrawalRequest: builder.mutation({
      query: (requestId) => ({
        url: `/members/savings/withdrawal-requests/${requestId}/cancel?guard=member`,
        method: "PUT",
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [
        { type: "MemberWithdrawalRequests", id: "LIST" },
        { type: "MemberContribution", id: "SUMMARY" },
      ],
    }),
  }),
});

export const {
  useCreateWithdrawalRequestMutation,
  useGetMyWithdrawalRequestsQuery,
  useCancelWithdrawalRequestMutation,
} = memberSavingsWithdrawalApi;

